module.exports = __webpack_public_path__ + "img/Las Vegas Bingo.59f185d8.jpeg";